// extracted by mini-css-extract-plugin
export default {"page-wrap":"Home_page-wrap__M1tSW","outerwrap":"Home_outerwrap__4bUSJ","db-error-message":"Home_db-error-message__m01Ak"};